import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { faBarcode, faCheck, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InstallmentActionButton } from './installment-action-button';
import { findCurrentLoanRePayments } from '../../../store/actions/loan-actions';

import { getPrice } from '../../../utils/helper/formatting';
import DateHelper from '../../../utils/helper/date-helper';
import * as loanStateEnum from '../../../utils/enumerator/enum-loan-state';

import ModalCreditCardOptions from '../../../pages/logged-area/components/modal-payment/modal-credit-card-options';
import ModalPixOptions from '../../../pages/logged-area/components/modal-payment/modal-pix-options';
import ModalSlipOptions from '../../../pages/logged-area/components/modal-payment/modal-slip-options';
import ModalAlert from '../modal-alert/modal-alert';
import ModalAnticipation from '../../../pages/logged-area/components/modal-payment/modal-anticipation';
import CreatePortal from '../create-portal';

import {
  getInstallmentState,
  LATE,
  LATE_FULLY_PAID_OFF,
  ON_TIME_FULLY_PAID_OFF,
  RESCHEDULED,
  RE_PAYMENT_PENDING_CONFIRMATION,
} from '../../../utils/enumerator/enum-installment-state';

import { AmountIcon, CardPaymentIcon, DateIcon, PixLogoIcon } from '../../../pages/logged-area/components/icons';

import './index.scss';

function InstallmentCardComponent(props) {
  const [showModalSlipOptions, setShowModalSlipOptions] = useState(false);
  const [showModalCreditCardOptions, setShowModalCreditCardOptions] = useState(false);
  const [showModalPixOptions, setShowModalPixOptions] = useState(false);
  const [showModalAnticipation, setShowModalAnticipation] = useState(false);

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [modalAlertContent, setModalAlertContent] = useState('');
  const [modalAlertTitle, setModalAlertTitle] = useState('');

  const { installment, totalInstallments } = props;
  const { number, owedAmount, paidAmount, state, dueDate, originalDueDate } = installment;
  const paidAmountFmtd = getPrice(paidAmount);
  const owedAmountFmtd = getPrice(owedAmount);
  const installmentState = getInstallmentState(state);

  const HOME_CLIENT_AREA_PATHNAME = ['/cliente', '/cliente/', '/cliente/resumo', '/cliente/resumo/'].includes(
    window.location.pathname,
  );
  const loanStateId = props.loan?.state.id;

  const onModalAlertChange = (show, content, title) => {
    setShowModalAlert(show);
    setModalAlertContent(content);
    setModalAlertTitle(title);
  };

  return (
    <>
      <div
        id="installment-card"
        className="installment-card"
        style={{
          width: props.customWidth,
          maxWidth: props.customMaxWidth,
          margin: props.customMargin,
        }}
      >
        <div className="installment-card-top">
          {totalInstallments ? (
            <h3 className="installment-card-top-title">
              {number}ª PARCELA ({number} de {totalInstallments})
            </h3>
          ) : (
            <h3 className="installment-card-top-title">{number}ª PARCELA</h3>
          )}
          <span className={`text-semibold installment-card-top-state ${installmentState.class2}`}>
            {installmentState.label}
          </span>
        </div>
        <div className="installment-card-separator" />
        <div className="installment-card-bottom">
          <div className="installment-card-content">
            <div className="installment-card-content-value">
              <div className="installment-card-content-value-icon">
                <AmountIcon />
              </div>
              <div className="installment-card-content-value-amount">
                {state === ON_TIME_FULLY_PAID_OFF ||
                state === LATE_FULLY_PAID_OFF ||
                state === RE_PAYMENT_PENDING_CONFIRMATION ? (
                  <span>{paidAmountFmtd}</span>
                ) : (
                  <span>{owedAmountFmtd}</span>
                )}
                {/* {originalValue === value
                  ? <span>{value}</span>
                  : <>
                      <span>{value}</span>
                      <span className="original">{originalValue}</span>
                    </>
                } */}
              </div>
            </div>

            <div className="installment-card-content-date">
              <div className="installment-card-content-date-icon">
                <DateIcon /> <span>Vencimento:</span>
              </div>
              <div className="installment-card-content-due-date text-semibold ">
                {DateHelper.getFormattedDate(dueDate)}
              </div>
              {/* {dueDate === originalDueDate
                ? <div className="installment-card-content-due-date">
                  {DateHelper.getFormattedDate(dueDate)}
                </div>
                : <>
                  <div className="installment-card-content-due-date">
                    {DateHelper.getFormattedDate(dueDate)}
                  </div>
                  <div className="installment-card-content-due-date original">
                    {DateHelper.getFormattedDate(originalDueDate)}
                  </div>
                </>
              } */}
            </div>

            {!(
              installment.state === ON_TIME_FULLY_PAID_OFF ||
              installment.state === LATE_FULLY_PAID_OFF ||
              installment.state === RE_PAYMENT_PENDING_CONFIRMATION
            ) &&
              loanStateId != loanStateEnum.COLLECTION_SUSPENDED && (
                <>
                  {installment.bill && installment.bill.id ? (
                    <div className="installment-card-content-actions">
                      <InstallmentActionButton
                        icon={<FontAwesomeIcon icon={faBarcode} size="1x" color="#ffa842" />}
                        text="Opções do Boleto"
                        onClick={() => {
                          setShowModalSlipOptions(true);
                          props.setShowCurrentSlip && props.setShowCurrentSlip(true);
                        }}
                      />
                      {(installment.state === LATE || installment.state === RESCHEDULED) &&
                        installment.dueDays >= 3 && (
                          <InstallmentActionButton
                            icon={<CardPaymentIcon />}
                            text="Pagar com cartão"
                            onClick={() => setShowModalCreditCardOptions(true)}
                          />
                        )}
                      <InstallmentActionButton
                        icon={<PixLogoIcon />}
                        text="Pagar com PIX"
                        onClick={() => setShowModalPixOptions(true)}
                      />
                    </div>
                  ) : (
                    <div className="installment-card-content-actions">
                      <div className="installment-bill-not-available">
                        <span className="installment-message">
                          O pagamento desta parcela ainda não está disponível.
                        </span>

                        <InstallmentActionButton
                          icon={<FontAwesomeIcon icon={faRedo} size="1x" color="#ffa842" />}
                          text="Simular antecipação"
                          onClick={() => setShowModalAnticipation(true)}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            {(installment.state === ON_TIME_FULLY_PAID_OFF || installment.state === LATE_FULLY_PAID_OFF) && (
              <div className="installment-card-content-actions">
                <InstallmentActionButton
                  icon={<FontAwesomeIcon icon={faCheck} size="1x" color="#00BA88" />}
                  text="Depósito quitado!"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {showModalAlert && (
        <CreatePortal
          id="logged-in-area"
          removePortal={HOME_CLIENT_AREA_PATHNAME}
          render={
            <ModalAlert
              showModal={showModalAlert}
              closeModalFunction={() => onModalAlertChange(false)}
              content={modalAlertContent}
              title={modalAlertTitle}
            />
          }
        />
      )}

      {showModalAnticipation && (
        <CreatePortal
          id="logged-in-area"
          removePortal={HOME_CLIENT_AREA_PATHNAME}
          render={
            <ModalAnticipation
              show={showModalAnticipation}
              loanId={props.loanId}
              onClose={() => {
                setShowModalAnticipation(false);
                onModalAlertChange(false);
              }}
              closeModalFunction={() => {
                setShowModalAnticipation(false);
                onModalAlertChange(false);
              }}
              installment={installment}
              onModalAlertChange={onModalAlertChange}
            />
          }
        />
      )}

      {(showModalSlipOptions || props.showCurrentSlip) && (
        <CreatePortal
          id="logged-in-area"
          removePortal={HOME_CLIENT_AREA_PATHNAME}
          render={
            <ModalSlipOptions
              show={showModalSlipOptions || props.showCurrentSlip}
              onClose={() => {
                setShowModalSlipOptions(false);
                props.findCurrentLoanRePayments(props.device);
                props.setShowCurrentSlip && props.setShowCurrentSlip(false);
              }}
              onModalAlertChange={onModalAlertChange}
              installment={installment}
              loanId={props.loanId}
            />
          }
        />
      )}

      {showModalCreditCardOptions && (
        <CreatePortal
          id="logged-in-area"
          removePortal={HOME_CLIENT_AREA_PATHNAME}
          render={
            <ModalCreditCardOptions
              show={showModalCreditCardOptions}
              onClose={() => {
                setShowModalCreditCardOptions(false);
                props.findCurrentLoanRePayments(props.device);
              }}
              onModalAlertChange={onModalAlertChange}
              installments={[installment]}
            />
          }
        />
      )}

      {showModalPixOptions && (
        <CreatePortal
          id="logged-in-area"
          removePortal={HOME_CLIENT_AREA_PATHNAME}
          render={
            <ModalPixOptions
              show={showModalPixOptions}
              onClose={() => {
                setShowModalPixOptions(false);
                props.findCurrentLoanRePayments(props.device);
              }}
              onModalAlertChange={onModalAlertChange}
              installment={installment}
              loanId={props.loanId}
            />
          }
        />
      )}
    </>
  );
}

InstallmentCardComponent.propTypes = {
  installment: PropTypes.object.isRequired,
  totalInstallments: PropTypes.number.isRequired,
  loanId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  device: state.customer.device,
  loan: state.personalLending.loan,
});

const mapDispatchToProps = (dispatch) => ({
  findCurrentLoanRePayments: (device) => dispatch(findCurrentLoanRePayments(device)),
});

const InstallmentCard = connect(mapStateToProps, mapDispatchToProps)(InstallmentCardComponent);

export { InstallmentCard };
